var lowerCase = require('lower-case');
/**
 * Lower case the first character of a string.
 *
 * @param  {String} str
 * @return {String}
 */


module.exports = function (str, locale) {
  if (str == null) {
    return '';
  }

  str = String(str);
  return lowerCase(str.charAt(0), locale) + str.substr(1);
};